// extracted by mini-css-extract-plugin
export default {"slide":"rp1X3","card":"ibpoU","slide-active":"kY0Wn"};